// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__g1mR0","sendOtp":"AuthorizeToLogin_sendOtp__1BfOI"};